$(document).ready(function () {
    //first carousal for stacked mobile variant
    $slick_slider = $('.featured-cards--stacked .carousel-container');
    settings = {
            autoplay: false,
            adaptiveHeight: false,
            infinite: true,
            centerMode: true,
            variableWidth: true,
            dots: true,
            mobileFirst: true,
            speed: 1500,
            focusOnChange: true,
            accessibility: true, 
            slidesToShow: 1,
            slidesToScroll: 1, 
            customPaging : function(slider, i) {
                if (i == (slider.$slides.length - 1)) {
                    return '<a class="last-item">'+(i+1)+'&nbsp'+'</a>' + '&nbsp/&nbsp'+'<a>'+(i+1)+'</a>';
                } else {
                    return '<a>'+(i+1)+'&nbsp'+'</a>';
                }
            },
            responsive: [
                {
                    breakpoint: 767.9,
                    settings: "unslick"
                },
            ]
    }

    $slick_slider.on('init', function (event, slick) {
        $('.featured-cards--stacked').removeClass('featured-cards--loading');
    });

    $slick_slider.slick(settings);


    //second carousal for carousal variant
    $slick_slider_carousel = $('.featured-cards--carousel .carousel-container');
    settings_carousel = {
            autoplay: false,
            adaptiveHeight: false,
            infinite: true,
            centerMode: true,
            variableWidth: true,
            dots: true,
            mobileFirst: true,
            speed: 1500,
            focusOnChange: true,
            accessibility: true, 
            customPaging : function(slider, i) {
                if (i == (slider.$slides.length - 1)) {
                    return '<a class="last-item">'+(i+1)+'&nbsp'+'</a>' + '&nbsp/&nbsp'+'<a>'+(i+1)+'</a>';
                } else {
                    return '<a>'+(i+1)+'&nbsp'+'</a>';
                }
            },
            responsive: [
                {
                breakpoint: 1400,
                    settings: {
                        infinite: false,
                        centerMode: false,
                        slidesToScroll: 4,
                        slidesToShow: 4,
                        customPaging : function(slider, i) {
                           return '<button tabindex="0" class="carousel-indicator">'+'</button>';
                        }
                    }
                },
                {
                breakpoint: 1024,
                    settings: {
                        infinite: false,
                        centerMode: false,
                        slidesToScroll: 3,
                        slidesToShow: 3,
                        customPaging : function(slider, i) {
                           return '<button tabindex="0" class="carousel-indicator">'+'</button>';
                        }
                    }
                },
                {
                breakpoint: 767.9,
                    settings: {
                        infinite: false,
                        centerMode: false,
                        slidesToScroll: 2,
                        slidesToShow: 2,
                        customPaging : function(slider, i) {
                           return '<button tabindex="0" class="carousel-indicator">'+'</button>';
                        }
                    }
                },
                {
                breakpoint: 576,
                    settings: {
                        infinite: true,
                    }
                }
            ]
    }


    $slick_slider_carousel.on('init', function (event, slick) {
        $('.featured-cards--carousel').removeClass('featured-cards--loading');
    });

    $slick_slider_carousel.slick(settings_carousel);

    setCorrectTabIndexOnIndicators();

    if ($(window).width() >= 767.9) {
        if ($slick_slider.hasClass('slick-initialized')) {
            $slick_slider.slick('unslick');
        }
        $('.cta-button-popup-modal__video.modal').on('show.bs.modal', onModalShow);
        return
    }

    if (!$slick_slider.hasClass('slick-initialized')) {
        return $slick_slider.slick(settings);
    }
});

var ytApiLoaded = false;
function loadYouTubeAPI() {
if (ytApiLoaded) return;
ytApiLoaded = true;
const tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
const firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}

// Append params like enablejsapi=1
function appendIframeParams(ytIframe) {
    if (!ytIframe) return;

    const iframe = $(ytIframe);
    let src = iframe.attr('src');

    const params = [
        { param: 'enablejsapi', value: '1' },
        { param: 'rel', value: '0' },
        { param: 'modestbranding', value: '1' }
    ];

    const url = new URL(src, window.location.origin);
    const searchParams = url.searchParams;

    for (const { param, value } of params) {
        if (!searchParams.has(param)) {
            searchParams.set(param, value);
        }
    }

    url.search = searchParams.toString();
    iframe.attr('src', url.toString());
}

//  For Brightcove video
// Check if videojs is loaded     
function waitForBrightcove(callback) {
    if (typeof videojs !== "undefined") {
        callback();
    } else {
        setTimeout(function () {
            waitForBrightcove(callback);
        }, 500);
    }
}
const ytPlayers = new Map();
function onModalShow(e) {
    $('.cta-button-popup-modal__video.modal').focus();
    $('.cta-button-popup-modal__video.modal .btn-close').attr('tabindex', '0'); 

    setTimeout(function () {
        $('.cta-button-popup-modal__video.modal iframe').attr('tabindex', '0'); // Ensure iframe is focusable
    }, 100);
                    var modal = $(e.target);
                    const modalId = modal.attr("id");
                    console.log("Modal ID:", modalId);
                    const $ctaBtn = $(`[data-bs-target="#${modalId}"]`).first();
                    console.log("CTA Button:", $ctaBtn);
                    const parentComponent = $ctaBtn.closest('.featured-cards');
                
           
                    if ($ctaBtn.length === 0) {
                        console.warn("No CTA found for modal:", modalId);
                        return;
                    }
                    if ($ctaBtn.length === 0) {
                        console.warn("No CTA found for modal:", modalId);
                        return;
                    }

                    if (parentComponent.length === 0){
                        return;
                    }

                      /* For Youtube video */
                if (parentComponent.length > 0) {
                    
                    const ytIframe = modal.find('iframe[src*="youtube"]')[0];
                
                    if (ytIframe) {
                        appendIframeParams(ytIframe);
                        const iframeId = ytIframe.id || `yt-iframe-${Date.now()}`;
                        ytIframe.id = iframeId; // ensure it has an ID
                
                        function createYTPlayerWhenReady() {
                        const player = new YT.Player(ytIframe, {
                            events: {
                            'onStateChange': function (event) {
                                if (event.data === YT.PlayerState.PLAYING) {
                                console.log("YouTube video play detected.");
                                trackAnalytics($(ytIframe), player);
                                }
                            }
                            }
                        });
                
                        ytPlayers.set(iframeId, player);
                        }
                
                        // If API already loaded
                        if (window.YT && window.YT.Player) {
                        createYTPlayerWhenReady();
                        } else {
                        // If API not ready, queue it
                        window.onYouTubeIframeAPIReady = function () {
                            createYTPlayerWhenReady();
                        };
                        }
                
                        loadYouTubeAPI(); // Load the script only once
                    }
                     /* For Youtube video */
                     /* For Brightcove video */
                    waitForBrightcove(initVideoEvents);
                    function initVideoEvents() {
                        modal.find(".video-js").each(function () {
                            console.log("it is inside video");
                            var videoElem = this;
                            if (!$(videoElem).data("initialized")) {
                                var bcPlayer = videojs(videoElem);
                                var videoId = $(videoElem).attr("data-video-id") || "video-" + Math.random();
                
                                $(videoElem).data("initialized", true);
                
                                bcPlayer.ready(function () {
                                    //  console.log("Brightcove Video Duration Found:", videoDurations[videoId]);
                                    bindPlayerEvents(bcPlayer, videoId);
                                });
                            }
                        });
                    }
    
                    function bindPlayerEvents(player, videoId) {
    
                        console.log("bindPlayerEvents");
    
                        player.ready(function () {
                            // console.log("Player " + videoId + " is ready, binding events...");
                
                            player.on("play", function () {
                                //  console.log("Video " + videoId + " playing, pausing other videos...");
                                trackAnalytics(player, videoId);
                                // Pause carousel if the video is inside one
                            });
                        })
                    }
                 /* For Brightcove video */
                    function trackAnalytics() {
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            event: "componentInteraction",
                            interactionType: "videoPlay",
                            elementClicked: "video",
                             // left arrow, right arrow, hit indicator
                            "featuredCards": {
                            "name": "featuredCards",
                            "title": contentTitle($ctaBtn),
                            "ctaText": "",
                            "destinationURL": "",
                            },
                        });
                        console.log('Tracked YouTube videoPlay event');
                    }
                }
    
}
function contentTitle($ctaBtn) {
    const header = $ctaBtn.closest(".featured-card__text-box")
    .find(".featured-card__heading")
    .find("h1, h2, h3, h4, h5, h6")
    .text();
    return header.trim();
}


$('.featured-cards--carousel .carousel-container').on('afterChange', function(event, slick, currentSlide, nextSlide){
     setTimeout(function() {
        setCorrectTabIndexOnIndicators();
    }, 100);
});

$('.featured-cards--carousel .carousel-container').on('setPosition', function(event, slick, currentSlide, nextSlide){
    if ($(window).width() >= 767.9) {
        setTimeout(function() {
            calculateArrowsDistance();
        }, 0);
    }
});


$(window).on('resize', function() {
    setCorrectTabIndexOnIndicators();

    if ($(window).width() >= 767.9) {
        setTimeout(function() {
            calculateArrowsDistance();
        }, 0);
        if ($slick_slider.hasClass('slick-initialized')) {
            $slick_slider.slick('unslick');
        }
        return;

    }

    if (!$slick_slider.hasClass('slick-initialized')) {
        return $slick_slider.slick(settings);
    }
    
});

function calculateArrowsDistance() {
    const dots = document.querySelectorAll('.slick-dots');
    const prev = document.querySelectorAll('.slick-prev');
    const next = document.querySelectorAll('.slick-next');
    
    if (dots && dots.length > 0 && prev && prev.length > 0 && next && next.length > 0) {
        dots.forEach(function (dot, index) {
            const dotCount = dot.children.length;
            const spacing = (dotCount * 43 + (dotCount-1) * 14) + 55; 
            const prevCurrentLeft = $(prev[index]).css("left");
            next[index].style.left = `calc(${prevCurrentLeft} + ${spacing}px)`;
        })
    }
}

function setCorrectTabIndexOnIndicators() {
    const indicators = document.querySelectorAll('.carousel-indicator');
    const prevArrow = document.querySelectorAll('.slick-prev');
    const nextArrow = document.querySelectorAll('.slick-next');

    indicators.forEach(function(i) {
        $(i).attr('tabindex', '0');
        $(i).attr('aria-hidden', false);
    })

    prevArrow.forEach(function(i) {
        $(i).attr('tabindex', '0');
        $(i).attr('aria-hidden', false);
    })

    nextArrow.forEach(function(i) {
        $(i).attr('tabindex', '0');
        $(i).attr('aria-hidden', false);
    })

    if ($(window).width() >= 767.9) {
        const slidesStacked = document.querySelectorAll('.featured-cards--stacked .featured-card');
        const slidesStackedLinks = document.querySelectorAll('.featured-cards--stacked .featured-card a');
        slidesStacked.forEach(function(i) {
            $(i).attr('aria-hidden', false);
        })

        slidesStackedLinks.forEach(function(i) {
            $(i).attr('tabindex', '0');
            $(i).attr('aria-hidden', false);
        })
    } 
}


/*Analytics*/
analytics.eventConfig.push({
    "target": ".body-wrapper", // featured cards
    "events": [
        {
            "eventTarget": ".featured-cards .heading-section .heading-section__title-container a", 
            "eventType": "click",
            "tags": {
                "event": "componentInteraction",
                "interactionType": "click", // left arrow, right arrow, hit indicator
                "featuredCards": {
                    "name": "featuredCards",
                    "elementClicked": "link"
                },
            }
        },
        {
            "eventTarget": ".featured-cards .heading-section .heading-section__copy a", 
            "eventType": "click",
            "tags": {
                "event": "componentInteraction",
                "interactionType": "click", // left arrow, right arrow, hit indicator
                "featuredCards": {
                    "name": "featuredCards",
                    "elementClicked": "link"
                },
            }
        },
        {
            "eventTarget": ".featured-cards .heading-section .heading-section__cta a", 
            "eventType": "click",
            "tags": {
                "event": "componentInteraction",
                "interactionType": "click", // left arrow, right arrow, hit indicator
                "featuredCards": {
                    "name": "featuredCards",
                    "elementClicked": "link"
                },
            }
        },
        {
            "eventTarget": ".featured-card .cta-button a.button-primary", 
            "eventType": "click",
            "tags": {
                "event": "componentInteraction",
                "interactionType": "click", // left arrow, right arrow, hit indicator
                "featuredCards": {
                    "name": "featuredCards",
                    "elementClicked": "button"
                },
            }
        },
        {
            "eventTarget": ".featured-card .cta-button a.button-secondary", 
            "eventType": "click",
            "tags": {
                "event": "componentInteraction",
                "interactionType": "click", // left arrow, right arrow, hit indicator
                "featuredCards": {
                    "name": "featuredCards",
                    "elementClicked": "button"
                },
            }
        },
        {
            "eventTarget": ".featured-card .cta-button a.button-secondary-white", 
            "eventType": "click",
            "tags": {
                "event": "componentInteraction",
                "interactionType": "click", // left arrow, right arrow, hit indicator
                "featuredCards": {
                    "name": "featuredCards",
                    "elementClicked": "button"
                },
            }
        },
        {
            "eventTarget": ".featured-card .cta-button-popup-modal a.button-primary", 
            "eventType": "click",
            "tags": {
                "event": "componentInteraction",
                "interactionType": "click", // left arrow, right arrow, hit indicator
                "featuredCards": {
                    "name": "featuredCards",
                    "elementClicked": "button"
                },
            }
        },
        {
            "eventTarget": ".featured-card .cta-button-popup-modal a.button-secondary", 
            "eventType": "click",
            "tags": {
                "event": "componentInteraction",
                "interactionType": "click", // left arrow, right arrow, hit indicator
                "featuredCards": {
                    "name": "featuredCards",
                    "elementClicked": "button"
                },
            }
        },
        {
            "eventTarget": ".featured-card .cta-button-popup-modal a.button-secondary-white", 
            "eventType": "click",
            "tags": {
                "event": "componentInteraction",
                "interactionType": "click", // left arrow, right arrow, hit indicator
                "featuredCards": {
                    "name": "featuredCards",
                    "elementClicked": "button"
                },
            }
        },
        {
            "eventTarget": ".featured-card .cta-button a.button-tertiary", 
            "eventType": "click",
            "tags": {
                "event": "componentInteraction",
                "interactionType": "click", // left arrow, right arrow, hit indicator
                "featuredCards": {
                    "name": "featuredCards",
                    "elementClicked": "link"
                },
            }
        },
        {
            "eventTarget": ".featured-card .cta-button-popup-modal a.button-tertiary", 
            "eventType": "click",
            "tags": {
                "event": "componentInteraction",
                "interactionType": "click", // left arrow, right arrow, hit indicator
                "featuredCards": {
                    "name": "featuredCards",
                    "elementClicked": "link"
                },
            }
        },
        {
            "eventTarget": ".featured-card__copy li a", 
            "eventType": "click",
            "tags": {
                "event": "componentInteraction",
                "interactionType": "click", // left arrow, right arrow, hit indicator
                "featuredCards": {
                    "name": "featuredCards",
                },
            }
        },
        {
            "eventTarget": ".slick-prev", 
            "eventType": "click",
            "tags": {
                "event": "componentInteraction",
                "interactionType": "left arrow", // left arrow, right arrow, hit indicator
                "featuredCards": {
                    "name": "featuredCards",
                },
            }
        },
        {
            "eventTarget": ".slick-next", 
            "eventType": "click",
            "tags": {
                "event": "componentInteraction",
                "interactionType": "right arrow", // left arrow, right arrow, hit indicator
                "featuredCards": {
                    "name": "featuredCards",
                },
            }
        },
        {
            "eventTarget": ".slick-dots li", 
            "eventType": "click",
            "tags": {
                "event": "componentInteraction",
                "interactionType": "hit indicator", // left arrow, right arrow, hit indicator
                "featuredCards": {
                    "name": "featuredCards",
                },
            }
        },
    ]
});